<app-header class="full-width" [noFamiliarisationBar]="true"></app-header>
<main id="content" class="js-content" role="main">
        <div class="grid-row">
            <header>
                <h1 class="heading-xlarge">Local Storage is not enabled on your browser</h1>
            </header>
            <div class="notice">
                <strong class="visually-hidden">Warning</strong>
                <app-svg-warning></app-svg-warning>
                <strong class="aa-copy-size">
                    Please tell your teacher
                </strong>
            </div>

            <br />
            <details>
                <summary><span class="summary aa-copy-size">Instructions for teachers</span></summary>
                <div class="panel no-border">
                    <ol class="list list-number aa-copy-size">
                        <li>If you are using a private browsing window, please switch to a non-private browsing window.</li>
                        <li>If the error persists, ensure you are using the latest version of your browser and that local storage is enabled.</li>
                        <li> If the above does not work, contact the national curriculum assessment helpline, using
                            the contact details below.</li>
                    </ol>
                    <div class="panel panel-border-wide aa-copy-size aa-contrast-border">
                        <div class="bold-small aa-copy-size">National curriculum assessments helpline</div>
                        <div>Telephone: 0300 303 3013</div>
                        <div>Monday to Friday, 9am to 5pm</div>
                    </div>
                </div>
            </details>
        </div>

</main>
<app-footer></app-footer>
